<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator :color="'#000'" />
       <VitePwaManifest />
      <NuxtPage />
    </NuxtLayout>
     <div class="preloader-curtain" data-animate="preloader-curtain"></div>
  </div>
</template>

<script setup>
import { useDatoStore } from '@/store/dato.js'
const { locale } = useI18n()
await useAsyncData(() => useDatoStore().fetchConfiguration(locale.value))

watch(
  () => locale.value,
  async () => {
    await useAsyncData(() => useDatoStore().fetchConfiguration(locale.value))
  }
)

const { lenis } = useLenis()
provide('lenis', lenis)
</script>
